import { useCallback, useMemo } from "react";

import { changeLanguage } from "core/i18n";

import { useLanguageStore } from "../contexts";
import type { SupportedLanguages } from "../types";

const useLanguage = () => {
	const store = useLanguageStore();
	const { setState, setInitial } = useLanguageStore();

	const methods = useMemo(() => {
		return {
			switchLanguage: (newLanguage: SupportedLanguages) => {
				setState({ activeLanguage: newLanguage });
				changeLanguage(newLanguage);
			},
			resetStore: () => {
				setInitial();
			}
		};
	}, [setInitial, setState]);

	const getData = useCallback(() => {
		return store;
	}, [store]);

	return { ...methods, getData };
};

export default useLanguage;
